export default {
    filterOption: {
        // 한 페이지당 보여질 항목 개수
        pageSize: 10,
        // 현재 페이지
        pageNumber: 1,
        // 조회 카테고리(HUB, STORE, WORKER)
        selectedCategory: '',
        // 설정 유형
        selectedType: '',
        // 조회기간
        betweenDate: [],
    },
    paginationData: {},
    list: [
        // 추후 api 확정 후 변수명 수정 필요
        {
            attributedDate: '2022-09',
            paymentYearDate: '2022-09-30',
            nameIncomeEarner: '홍길동이',
            socialNumber: '000000 - *******',
            incomeClassification: '퀵서비스',
            totalAmount: '000,000 원',
            vatRate: '00%',
            incomeTaxAmount: '00,000 원',
            localIncomeTaxAmount: '00,000 원',
        },
        {
            attributedDate: '2022-09',
            paymentYearDate: '2022-09-30',
            nameIncomeEarner: '홍길동이',
            socialNumber: '000000 - *******',
            incomeClassification: '퀵서비스',
            totalAmount: '000,000 원',
            vatRate: '00%',
            incomeTaxAmount: '00,000 원',
            localIncomeTaxAmount: '00,000 원',
        },
        {
            attributedDate: '2022-09',
            paymentYearDate: '2022-09-30',
            nameIncomeEarner: '홍길동이',
            socialNumber: '000000 - *******',
            incomeClassification: '퀵서비스',
            totalAmount: '000,000 원',
            vatRate: '00%',
            incomeTaxAmount: '00,000 원',
            localIncomeTaxAmount: '00,000 원',
        },
        {
            attributedDate: '2022-09',
            paymentYearDate: '2022-09-30',
            nameIncomeEarner: '홍길동이',
            socialNumber: '000000 - *******',
            incomeClassification: '퀵서비스',
            totalAmount: '000,000 원',
            vatRate: '00%',
            incomeTaxAmount: '00,000 원',
            localIncomeTaxAmount: '00,000 원',
        },
        {
            attributedDate: '2022-09',
            paymentYearDate: '2022-09-30',
            nameIncomeEarner: '홍길동이',
            socialNumber: '000000 - *******',
            incomeClassification: '퀵서비스',
            totalAmount: '000,000 원',
            vatRate: '00%',
            incomeTaxAmount: '00,000 원',
            localIncomeTaxAmount: '00,000 원',
        },
    ],
};
